import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ashbin-fill 239",
  "use": "icon-ashbin-fill 239-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-ashbin-fill 239\"><path d=\"M416 394.645333l0.298667 318.506667h64l-0.298667-318.506667h53.013333L533.333333 713.152h64l-0.32-318.506667h135.424L704.426667 792.64a64 64 0 0 1-63.829334 59.498667H368.768a64 64 0 0 1-63.829333-59.52L276.885333 394.666667l139.114667-0.021334zM181.333333 288h640v64h-640v-64z m453.482667-106.666667v64h-256v-64h256z\" p-id=\"18095\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol